import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { GridTypeEnum } from '../../../constants/grid-type.enum';
import { IGlobalEmployeeOverrideModel } from '../../../entities-api/IGlobalEmployeeOverrideModel';

@Component({
  selector: 'opm-audit-log-grid',
  templateUrl: './opm-audit-log-grid.component.html',
  styleUrls: ['./opm-audit-log-grid.component.less'],
  standalone: false
})
export class OpmAuditLogGridComponent implements OnInit {
  constructor(private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private router: Router
  ) { }

  users: IGlobalEmployeeOverrideModel[];
  gridTypeEnum = GridTypeEnum;
  fullName: string;

  ngOnInit() {
    window.scrollTo(0, 0);

    this.activatedRoute.params.subscribe((params: Params) => {
      var userId: string = params['userId'];
      this.userService.getOverrides(userId)
        .then((data: IGlobalEmployeeOverrideModel[]) => {
          if (data.length === 0) {
            return;
          }

          this.users = data;
          this.users.sort((a: IGlobalEmployeeOverrideModel, b: IGlobalEmployeeOverrideModel) => {
            return a.CreatedDate > b.CreatedDate ? -1 : 1;
          });

          this.fullName = this.users[0].PreferredFullName;
        })
        .catch(err => {
          this.router.navigate(["/"]);
          return;
        });
    });
  }
}
